<template>
  <div class="content">
    <v-row>
      <v-col cols="6">
        <h1 class="title">{{ $t("conductors.title") }}</h1></v-col
      >
      <v-col cols="6" align="end">
        <v-btn @click="handleCreateUser()" color="primary">{{
          $t("users.create")
        }}</v-btn></v-col
      >
    </v-row>
    <div class="table">
      <table-list-users
        v-if="!isLoading"
        :headerList="tableHeaders"
        :userList="users"
        :seenAttrs="userSeenAttrs"
        :itemActionList="actions"
        userType="conductors"
        @buttonClicked="handleActionClicked"
        @userChanged="handleUserEdit"
        @userDelete="handleUserDelete"
      />
      <v-card v-else class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </v-card>
    </div>
  </div>
</template>

<script>
import TableListUsers from "@/components/global/tableListComponents/TableListUsers";
import EditConductorModal from "@/components/global/modalComponents/EditUserModal/EditConductorModal";
import { mapActions } from "vuex";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "Conductors",
  props: {},
  components: {
    TableListUsers,
  },
  data() {
    return {
      users: [],
      userSeenAttrs: [
        "fullname",
        "par_id",
        "username",
        "active",
        "last_login",
        "last_activity",
      ],
      actions: [
        {
          icon: "mdi-edit",
          type: "edit",
        },
      ],
      isLoading: true,
    };
  },
  created() {
    this.emitter.on("userDeleteConfirm", this.handleUserDelete);
    this.emitter.on("buttonClicked", this.handleActionClicked);
  },
  mounted() {
    this.getConductorList();
  },
  methods: {
    ...mapActions({
      getConductors: "users/getConductors",
      createConductor: "users/createConductor",
      editConductor: "users/editConductor",
      deleteConductor: "users/deleteConductor",
    }),

    getConductorList() {
      this.isLoading = true;
      this.getConductors()
        .then((response) => {
          this.users = response.result;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleCreateUser() {
      this.emitter.emit("showComponentModalModal", {
        bind: {
          is: EditConductorModal,
          isCreate: true,
        },
        on: {
          createNewUser: (createPayload) => {
            this.createConductor(createPayload)
              .then(() => {
                toast.success(this.$t("conductors.toast.successCreate"));
                this.getConductorList();
              })
              .catch(() => {});
          },
        },
      });
    },
    handleUserDelete(user) {
      this.deleteConductor(user)
        .then(() => {
          toast.success(this.$t("conductors.toast.successDelete"));
          this.getConductorList();
        })
        .catch(() => {});
    },
    handleUserEdit(createPayload) {
      this.editConductor(createPayload)
        .then(() => {
          toast.success(this.$t("conductors.toast.successEdit"));
          this.getConductorList();
        })
        .catch(() => {});
    },
  },
  computed: {
    tableHeaders() {
      const headers = [
        {
          title: this.$t("conductors.table.headers.name"),
          textAlign: "text-left",
          value: "fullname",
        },
        {
          title: this.$t("conductors.table.headers.partner"),
          textAlign: "text-left",
          value: "partner",
        },
        {
          title: this.$t("conductors.table.headers.userName"),
          textAlign: "text-left",
          value: "username",
        },
        {
          title: this.$t("conductors.table.headers.active"),
          textAlign: "text-left",
          value: "active",
        },
        {
          title: this.$t("conductors.table.headers.lastLogin"),
          textAlign: "text-left",
          value: "last_login",
        },
        {
          title: this.$t("conductors.table.headers.lastTransaction"),
          textAlign: "text-left",
          value: "last_activity",
        },
        {
          title: this.$t("conductors.table.headers.actions"),
          textAlign: "text-right",
          value: "actions",
        },
      ];
      return headers;
    },
  },
  beforeUnmount() {
    this.emitter.off("userDeleteConfirm", this.handleUserDelete);
  },
};
</script>

<style lang="scss" scoped></style>
